import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const AboutSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-16 bg-gray-50" id="about" data-testid="about-section">
      <div className="max-w-[1800px] mx-auto px-6">
        <h2
          className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-10 leading-tight"
          style={{ color: '#702963' }}
          data-testid="about-main-title"
        >
          {getTranslation(language, 'aboutMainTitle')}
        </h2>

        <div className="max-w-5xl mx-auto space-y-8 text-gray-700">
          <p
            className="text-lg md:text-xl leading-relaxed text-center"
            data-testid="about-intro-paragraph"
          >
            {getTranslation(language, 'aboutIntroParagraph')}
          </p>

          <div className="pt-4">
            <h3
              className="text-2xl md:text-3xl font-bold mb-4 text-gray-800"
              data-testid="about-missions-title"
            >
              {getTranslation(language, 'aboutMissionsTitle')}
            </h3>
            <p className="text-lg md:text-xl leading-relaxed mb-6" data-testid="about-missions-paragraph-1">
              {getTranslation(language, 'aboutMissionsParagraph1')}
            </p>
            <p className="text-lg md:text-xl leading-relaxed" data-testid="about-missions-paragraph-2">
              {getTranslation(language, 'aboutMissionsParagraph2')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
